import React from 'react';
import { connect } from 'react-redux';
import { ls } from '@lib/local-storage';
import { Modal, withModals } from './modal';
import { lifecycle, compose, withHandlers } from 'recompose';
import { selectFreeSpace } from '../../cabinet-widget/selectors';
import { selectUserData } from '../selectors';
import { EndOfDiskSpaceModalView } from '../atoms/';
import { businessvr, pro, proplus } from '../constants';

const mapStateToProps = (state) => ({
  quotaFreePercent: selectFreeSpace(state).quotaFreePercent,
  quotaFree: selectFreeSpace(state).quotaFree,
  quotaLimit: selectFreeSpace(state).quotaLimit,
  tariff: selectUserData(state).tariff,
});

const timeInterval = 43200000; // интервал показа модального окна раз в 12 часов
const checkCurrentTariff = (tariff) => {
  if (tariff === businessvr || tariff === pro || tariff === proplus) {
    return true;
  }
  return false;
};

const enchance = compose(
  connect(mapStateToProps),
  withModals(['endOfDiskSpace']),
  lifecycle({
    componentDidUpdate() {
      const { quotaFreePercent, openModal, tariff } = this.props;

      if (
        checkCurrentTariff(tariff?.alias) &&
        quotaFreePercent &&
        100 - quotaFreePercent < 15 &&
        Date.now() - ls.getItem('diskSpaceModalTimestamp') > timeInterval
      ) {
        openModal('endOfDiskSpace');
        ls.setItem('diskSpaceModalTimestamp', Date.now());
      }
    },
  }),
  withHandlers({
    onClose: ({ closeModals }) => () => {
      closeModals();
    },
  })
);

const EndOfDiskSpaceModalWrapper = ({ onClose, modals, quotaFree, quotaFreePercent, quotaLimit, tariff }) => (
  <Modal isOpen={modals.endOfDiskSpace.isOpen} closeModal={onClose}>
    <EndOfDiskSpaceModalView
      onClose={onClose}
      quotaFree={quotaFree}
      quotaFreePercent={quotaFreePercent}
      quotaLimit={quotaLimit}
      tariff={tariff}
    />
  </Modal>
);

export const EndOfDiskSpaceModal = enchance(EndOfDiskSpaceModalWrapper);
